module.exports = __webpack_public_path__ + "static/bilsland-griffith-benefit-administrators-logo-c3e6292a44ef5dcfaa51b8c7104820f3.jpg";